// import React, { useState, useEffect,useRef } from "react";
// import NavMenu from "../Navbar";
// import Footer from "../Footer";
// import "../../assets/style.css";
// import axios from "axios";
// import { loginApi, getUserOtp, userValidation } from "../../api/api";
// import Home from "../Home"
// import { Modal } from 'react-bootstrap';
// import Loginotp from './Loginotp';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';


// const NewAcount = () => {
//   const [Name, setName] = useState("");
//   const [password,setPassword] = useState('')
//   const [mobileNo, setmobileNo] = useState("");
//   const [mobileNo2, setmobileNo2] = useState("");
//   const [email, setEmail] = useState("");
//   const [address, setaddress] = useState("");
//   const [pincode, setpincode] = useState("");
//   const [city, setcity]= useState("");
//   const [status, setStatus] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [showTooltip2, setShowTooltip2] = useState(false);
//   const [toolMsg, setToolMsg] = useState('')
//   const [toolMsg2, setToolMsg2] = useState('')


//   // const nameRef = useRef();
//   // const mobileNoRef = useRef();
//   // const pincodeRef = useRef();
//   useEffect(()=>{
//     window.scrollTo(0, 0);
//     window.history.scrollRestoration = 'manual'
//   },[])

//   const formHandler = () => {

//     if(!isChecked){
//       alert('Please agree terms and conditions')
//       setStatus(false)
//       return;
//     }
    
//     const emailRegex = /\S+@\S+\.\S+/;
//     if (!emailRegex.test(email)) {
//       alert("Please enter a valid email address.");
//       setStatus("fail");
//       return;
//     }

//     if (mobileNo.length !== 10 || !/^[0-9]+$/.test(mobileNo)) {
//       alert("Please enter a valid 10-digit mobile number.");
//       setStatus(false);
//       return;
//     }

//     if (mobileNo2.length !== 10 || !/^[0-9]+$/.test(mobileNo)) {
//       alert("Please enter a valid 10-digit whatsapp number.");
//       setStatus(false);
//       return;
//     }
  
//     if (pincode.length !== 6 || !/^[0-9]+$/.test(pincode)) {
//       alert("Please enter a valid 6-digit pincode.");
//       setStatus(false);
//       return;
//     }

//     if (mobileNo.length !== 10) {
//       alert("Please enter a 10-digit mobile number.");
//       setStatus("fail");
//       return;
//     }

//     if (mobileNo2.length !== 10) {
//       alert("Please enter a 10-digit whatsapp number.");
//       setStatus("fail");
//       return;
//     }

//     if (pincode.length !== 6) {
//       alert("Please enter a 6-digit pincode.");
//       setStatus("fail");
//       return;
//     }

//     if (
//       Name.trim() === "" ||
//       mobileNo.trim() === "" ||
//       mobileNo2.trim() === "" ||
//       email.trim() === "" ||
//       address.trim() === "" ||
//       pincode.trim() === "" ||
//       city.trim() === ""
//     ) {
//       alert("Please enter all the details.");
//       setStatus(false);
//       return;
//     }

//     const userData = {
//       name: Name,
//       mobile: mobileNo,
//       mobile2:mobileNo2,
//       email: email,
//       address: address,
//       pincode: pincode,
//       city: city,
//       password:password
//     };

    

//     const url = loginApi()

//   console.log(" body  --> ", url , "    ", userData);
//     axios
//       .post(url, userData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       })
//       .then((response) => {
//         console.log('Response in resg:', response.data);
//         setStatus(true); 
//         if (response.data.status) {
//           navigateToDashboard()
//         }
//         else{
//           console.log('false');
//         }
//       })
//       .catch((error) => {
//         console.error('Error in register:', error);
//         setStatus(false);

//       })
//       .catch((error) => {
//         console.error('Error in register:', error);
//         setStatus(false); 
//       });
//   };

//   const navigateToDashboard = () => {
//     window.location.href = '/login'; // Replace '/dashboard' with the actual route of your destination page
//   }

//   const handleVerifyOtp = (otp) => {
//     const userData = {
//       otp: otp,
//       mobile: mobileNo,
//     };

//     const url = getUserOtp();

//     axios
//       .post(url, userData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         console.log('Response in resg:', response.data);
//         setStatus(true);
//         handleCloseModal();
//       })
//       .catch((error) => {
//         console.error('Error in register:', error);
//         setStatus(false);
//       });
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const handleShowModal = () => {
//     setShowModal(true);
//   };


//   function goBack() {
//     window.history.go(-1);
//   }
//   const handleCheckboxChange = (event) => {
//     setIsChecked(event.target.checked);
//   };



 
// const userDataValidation=()=>{
//   if (mobileNo.trim() !== '' ) {
//   const url=userValidation()
//   const body ={
//     mobile:mobileNo,
//     // email:email,
//   }

//   axios.post(url,body, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   })
//   .then((resp)=>{
//     console.log('==>resp',resp.data);
//     if(!resp.data.status){
//       // alert('mobile number already registered')

//       setShowTooltip(true)
//       setToolMsg(resp.data.message)
//     }
//     if(resp.data.status){
//       setShowTooltip(false)
//     }
//   })
//   .catch((error)=>{
//     console.log('==error',error);
//   })}
// }

// const userValids = ()=>{
//   if(mobileNo==10){
//     setShowTooltip2(false)
//   }
// }

// const userDataValidation2=()=>{
//   if (mobileNo.trim() !== '') {
//   const url=userValidation()
//   const body ={
//     // mobile:mobileNo,
//     email:email,
//   }

//   axios.post(url,body, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   })
//   .then((resp)=>{
//     console.log('==>resp',resp.data);
//     if(!resp.data.status){
//       // alert('mobile number already registered')
      
//       setShowTooltip2(true)
//       setToolMsg2(resp.data.message)
//     }
//     if(resp.data.status){
//       setShowTooltip2(false)
//     }
//   })
//   .catch((error)=>{
//     console.log('==error',error);
//   })
//   }

// }
//   return (
//     <>
//       <NavMenu />
//       <div className="container createCont">
//         <div className="row" style={{ justifyContent: "space-around" }}>
//           <div className="col-lg-5 col-12">
//             <p className="createAcoText ">CREATE NEW CUSTOMER ACCOUNT</p>
//             <div className=" createInputDiv">
//               <input
//               // ref={nameRef}
//                 type="name"
//                 className='createAcountInput '
//                 placeholder="username"
//                 value={Name}
//                 onChange={(e) => setName(e.target.value)}
//               />
//               <span className="errStar">*</span>
//             </div>

//             <div className="createInputDiv">
//               <input
//               // ref={mobileNoRef}
//                 type="name"
//                 className="createAcountInput"
//                 pattern="[7-9]{1}[0-9]{9}"
//                 placeholder="Contact Number"
//                 value={mobileNo}
//                 maxLength={10}
//                 onChange={(e) => setmobileNo(e.target.value)}
//                 onMouseLeave={userDataValidation}
//               />
//               <span className="errStar">*</span>


//              {showTooltip && 
//              <div style={{marginTop:'-8px'}}>
//               <span>{toolMsg}</span>
//               </div>
//               }
//             </div>

//             <div className="createInputDiv">
//               <input
//               //  ref={pincodeRef}
//                 placeholder="Email address"
//                 type="email"
//                 className="createAcountInput"
//                 value={email}
//                 pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
//                 onMouseLeave={userDataValidation2}
                
//                 onChange={(e) => setEmail(e.target.value)}
//               />
              
//               <span className="errStar">*</span>
//               {showTooltip2 && 
//               <div style={{marginTop:'-8px'}}>
//               <span>{toolMsg2}</span> </div>}
             
//             </div>
            
//             <div className=" createInputDiv">
//               <input
//               // ref={nameRef}
//                 type="text"
//                 className='createAcountInput '
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//               <span className="errStar">*</span>
//             </div>

//           </div>
     
            

//           <div className="col-lg-5 col-12 createPassGrid">
//             <div className="d-flex createInputDiv">
//               <input
//                 placeholder="Address"
//                 type="name"
//                 className="createAcountInput"
//                 value={address}
//                 onChange={(e) => setaddress(e.target.value)}
//               />
//               <span className="errStar">*</span>
//             </div>
            
//             <div className="d-flex createInputDiv">
//               <input
//                 placeholder="Pincode"
//                 type="name"
//                 className="createAcountInput"
//                 value={pincode}
//                 maxLength={6}
//                 onChange={(e) => setpincode(e.target.value)}
//               />
//               <span className="errStar">*</span>
//             </div>

//             <div className="d-flex createInputDiv">
//               <input
//                 placeholder="City"
//                 type="name"
//                 className="createAcountInput"
//                 value={city}
//                 onChange={(e) => setcity(e.target.value)}
//               />
//               <span className="errStar">*</span>
//             </div>

//             <div className=" d-flex createInputDiv">
//               <input
//               // ref={mobileNoRef}
//                 type="name"
//                 className="createAcountInput"
//                 pattern="[7-9]{1}[0-9]{9}"
//                 placeholder="Whatsapp Number"
//                 value={mobileNo2}
//                 maxLength={10}
//                 onChange={(e) => setmobileNo2(e.target.value)}
//                 onMouseLeave={userDataValidation}
//               />
//               <span className="errStar">*</span>


//              {showTooltip && 
//              <div style={{marginTop:'-8px'}}>
//               <span>{toolMsg}</span>
//               </div>
//               }
//             </div>
//           </div>
          
//         </div>
//       </div>
//       <div className="container">
//         <div className="row" style={{ justifyContent: "center" }}>
//           <div className="col-lg-5 col-12 createAcounBtn">
//           <span style={{display:'flex', justifyContent:'center'}}>  <input style={{marginTop:'-10px', marginRight:'5px'}} checked={isChecked} onChange={handleCheckboxChange} type="checkbox"/><p>Accept terms and conditions</p></span>
//             <input
//               value="Create an account"
//               className="singSecure"
//               type="button"
//               onClick={() => formHandler()}
//             />
            
//             <button className="singinBack" style={{border:'none', backgroundColor:'#fff', color:'gray'}} onClick={()=>{goBack()}}>BACK</button>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onHide={handleCloseModal} centered  size="lg" className='modalClass'  >
//         <Modal.Header closeButton style={{background:'rgba(241, 241, 241, 1)'}}>
//           {/* <Modal.Title>OTP Verification</Modal.Title> */}
//         </Modal.Header>
//         <Modal.Body style={{height:'450px', background:'rgba(241, 241, 241, 1)'}}>
//           <Loginotp mobileNo={mobileNo} onVerify={handleVerifyOtp} />
//         </Modal.Body>
//       </Modal>
//       <Footer />

   
//     </>
//   );
// };

// export default NewAcount;






import React, { useState, useEffect,useRef } from "react";
import NavMenu from "../Navbar";
import Footer from "../Footer";
import "../../assets/style.css";
import axios from "axios";
import { loginApi, getUserOtp, userValidation, tempData } from "../../api/api";
import Home from "../Home"
import { Modal, ModalHeader } from 'react-bootstrap';
import Loginotp from './Loginotp';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from "react-router-dom/dist";


const NewAcount = () => {
  const [Name, setName] = useState("");
  const [lastName, setlastName] = useState("");
  const [password,setPassword] = useState('')
  const [mobileNo, setmobileNo] = useState("");
  const [mobileNo2, setmobileNo2] = useState("");
  const [email, setEmail] = useState("");
  const [address, setaddress] = useState("");
  const [pincode, setpincode] = useState("");
  const [city, setcity]= useState("");
  const [status, setStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [toolMsg, setToolMsg] = useState('')
  const [toolMsg2, setToolMsg2] = useState('')
  const [gstn,setGstn] = useState('')
  const [companyName,setCompanyName] = useState('')
  const [company,setCompany] = useState(false)
  const [companyStatus, setCompanyStatus] = useState(0)


  // const nameRef = useRef();
  // const mobileNoRef = useRef();
  // const pincodeRef = useRef();
  useEffect(()=>{
    window.scrollTo(0, 0);
    window.history.scrollRestoration = 'manual'
  },[])

  const navigate = useNavigate()

  const formHandler1=()=>{
    if(!isChecked){
      alert('Please agree terms and conditions')
      setStatus(false)
      return;
    }
    
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      setStatus("fail");
      return;
    }

    if (mobileNo.length !== 10 || !/^[0-9]+$/.test(mobileNo)) {
      alert("Please enter a valid 10-digit mobile number.");
      setStatus(false);
      return;
    }

    if (mobileNo2.length !== 10 || !/^[0-9]+$/.test(mobileNo)) {
      alert("Please enter a valid 10-digit whatsapp number.");
      setStatus(false);
      return;
    }
  
    // if (pincode.length !== 6 || !/^[0-9]+$/.test(pincode)) {
    //   alert("Please enter a valid 6-digit pincode.");
    //   setStatus(false);
    //   return;
    // }

    if (mobileNo.length !== 10) {
      alert("Please enter a 10-digit mobile number.");
      setStatus("fail");
      return;
    }

    if (mobileNo2.length !== 10) {
      alert("Please enter a 10-digit whatsapp number.");
      setStatus("fail");
      return;
    }

    // if (pincode.length !== 6) {
    //   alert("Please enter a 6-digit pincode.");
    //   setStatus("fail");
    //   return;
    // }

    if (
      Name.trim() === "" ||
      lastName.trim() === "" ||
      mobileNo.trim() === "" ||
      mobileNo2.trim() === "" ||
      email.trim() === "" 
      // address.trim() === "" 
      // pincode.trim() === "" ||
      // city.trim() === ""
    ) {
      alert("Please enter all the details.");
      setStatus(false);
      return;
    }console.log('hello');
    TempData()
  }

  const TempData=()=>{
    const userData = {
      name: Name,
      last_name:lastName,
      mobile: mobileNo,
      mobile2:mobileNo2,
      email: email,
      is_company:companyStatus,
      company_name:companyName,
      gst_no:gstn,
      address: 'static',
      pincode: '000000',
      city: 'Mumbai',
      // password:password
    };

    

    const url = tempData()

  console.log(" body  --> ", url , "    ", userData);
    axios
      .post(url, userData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log('Response in resg:', response.data);
        setStatus(true); 
        if (response.data.status) {
          handleShowModal()
        }
        else{
          console.log('false',response);
          // alert(response.data.message)
        }
      })
      .catch((error) => {
        console.error('Error in register:', error);
        setStatus(false);

      })
      .catch((error) => {
        console.error('Error in register:', error);
        setStatus(false); 
      });
  };

const handleCompanyChange=()=>{
  if(company){
    setCompanyStatus(0)
  }else{
    setCompanyStatus(1)
  }
  setCompany(!company)
}



  // const handleVerifyOtp = (otp) => {
  //   const userData = {
  //     otp: otp,
  //     mobile: mobileNo,
  //   };

  //   const url = getUserOtp();

  //   axios
  //     .post(url, userData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     })
  //     .then((response) => {
  //       console.log('Response in resg:', response.data);
  //       setStatus(true);
  //       handleCloseModal();
  //     })
  //     .catch((error) => {
  //       console.error('Error in register:', error);
  //       setStatus(false);
  //     });
  // };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal2 = () => {
    setShowModal2(false);
  };

  const handleShowModal2 = () => {
    setShowModal2(true);
  };


  function goBack() {
    window.history.go(-1);
  }
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


const userDataValidation=()=>{
  if (mobileNo.trim() !== '' ) {
  const url=userValidation()
  const body ={
    mobile:mobileNo,
    // email:email,
  }

  axios.post(url,body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  .then((resp)=>{
    console.log('==>resp',resp.data);
    if(resp.data.status){
      // alert('mobile number already registered')

      setShowTooltip(false)
      // setToolMsg(resp.data.message)
    }else{
      setShowTooltip(true)
      setToolMsg(resp.data.message)
    }
    // if(resp.data.status){
    //   setShowTooltip(false)
    // }
  })
  .catch((error)=>{
    console.log('==error',error);
  })}
}

const userDataValidation2=()=>{
  if (email.trim() !== '') {
  const url=userValidation()
  const body ={
    // mobile:mobileNo,
    email:email,
  }

  axios.post(url,body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  .then((resp)=>{
    console.log('==>resp',resp.data);
    if(resp.data.status  ){
      // alert('mobile number already registered')
      
      setShowTooltip2(false)
      // setToolMsg2(resp.data.message)
    }
    else{
      setShowTooltip2(true)
      setToolMsg2(resp.data.message)
    }
    // if(resp.data.status){
    //   setShowTooltip2(false)
    // }
  })
  .catch((error)=>{
    console.log('==error',error);
  })
  }

}

const userValids = ()=>{
  if(mobileNo==10){
    setShowTooltip2(false)
  }
}

useEffect(() => {
  // Update the state and run your validation function
  // if(  mobileNo.length>=10){

    userDataValidation();
    userDataValidation2();
  // }
}, [mobileNo,email]);
  return (
    <>
      <NavMenu />
      <div className="container createCont">
        <div className="row" style={{ justifyContent: "space-around" }}>
          <div className="col-lg-5 col-12 createNewAllUser ">
            {/* <p className="createAcoText ">CREATE NEW CUSTOMER ACCOUNT</p>
           
              
              <div className="userNameDiv" >
              <div className=" createInputDiv">
              <input
              // ref={nameRef}
                type="name"
                className='createAcountInput '
                placeholder="Full Name"
                value={Name}
                onChange={(e) => setName(e.target.value)}
              />
              <span className="errStar">*</span>
            </div> */}

            {/* <div className="userNameDiv" >
            
            <div className=" createInputDiv">
              <input
              // ref={nameRef}
                type="password"
                className='createAcountInput '
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
            </div> */}


            {/* <div className="d-flex createInputDiv">
              <input
                placeholder="Address"
                type="name"
                className="createAcountInput"
                value={address}
                onChange={(e) => setaddress(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
            
            <div style={{display:'flex'}} className="pincodeCity">
            <div className="d-flex createInputDiv">
              <input
                placeholder="Pincode"
                type="name"
                className="createAcountInput2"
                value={pincode}
                maxLength={6}
                onChange={(e) => setpincode(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>

            <div className="d-flex createInputDiv">
              <input
                placeholder="City"
                type="name"
                className="createAcountInput2"
                value={city}
                onChange={(e) => setcity(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
            </div> */}
            </div>

          </div>
          {/* <div className="col-lg-5 col-12 createPassGrid"> */}
          <div className=" createPassGrid">
          <p className="createAcoText ">CREATE NEW CUSTOMER ACCOUNT</p>

          
             
                {/* <span style={{padding:'0px 5px 0px 5px', color:'black', fontSize:'18px', fontFamily:'rubik'}}> Contact Details </span> */}
            <div className="userNameDiv2" >
            <div className=" createInputDiv">
              <input
              // ref={nameRef}
                type="name"
                className='createAcountInput '
                placeholder="First Name"
                value={Name}
                onChange={(e) => setName(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
            <div className=" createInputDiv">
              <input
              // ref={nameRef}
                type="name"
                className='createAcountInput '
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setlastName(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
            <div className="createInputDiv">
              <input
              // ref={mobileNoRef}
                type="name"
                className="createAcountInput"
                pattern="[7-9]{1}[0-9]{9}"
                placeholder="Contact Number"
                value={mobileNo}
                maxLength={10}
                onChange={(e) => setmobileNo(e.target.value)}
                onMouseLeave={userDataValidation}
              />
              <span className="errStar">*</span>


             {showTooltip && 
             <div style={{marginTop:'-14px', marginBottom:'5px', fontSize:'12px', color:'red'}}>
              <span>{toolMsg}</span>
              </div>
              }
            </div>

            <div className="  createInputDiv">
              <input
              // ref={mobileNoRef}
                type="name"
                className="createAcountInput"
                pattern="[7-9]{1}[0-9]{9}"
                placeholder="Whatsapp Number"
                value={mobileNo2}
                maxLength={10}
                onChange={(e) => setmobileNo2(e.target.value)}
                // onMouseLeave={userDataValidation}
              />
              <span className="errStar">*</span>


             {/* {showTooltip && 
             <div style={{marginTop:'-8px'}}>
              <span>{toolMsg}</span>
              </div>
              } */}
            </div>

            <div className="createInputDiv">
              <input
              //  ref={pincodeRef}
                placeholder="Email address"
                type="email"
                className="createAcountInput"
                value={email}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                onMouseLeave={userDataValidation2}
                
                onChange={(e) => setEmail(e.target.value)}
              />
              
              <span className="errStar">*</span>
              {showTooltip2 && email.length !== '' && (
                <>
                <div style={{marginTop:'-14px', marginBottom:'5px', fontSize:'12px', color:'red'}}>
              <span>{toolMsg2}</span> </div>
                </>
              ) 
              }
             
            </div>
            <div style={{display:'flex',}}>
              <p style={{marginBottom:'0px'}}>Are you a company?</p>
              <input
              type="checkbox"
              style={{marginLeft:'10px' ,marginTop:'0px', width:'20px'}}
              // style={{marginLeft:'10px' ,marginTop:'-8px', width:'20px'}}
              onChange={handleCompanyChange}
              checked={company}
              />
            </div>

            {
              company && (
              <>
              <div className="  createInputDiv">
              <input
                type="name"
                className="createAcountInput"
                placeholder="Company Name"
                onChange={(e) => setCompanyName(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>

            <div className="  createInputDiv">
              <input
                type="name"
                className="createAcountInput"
                placeholder="GSTIN"
                onChange={(e) => setGstn(e.target.value)}
              />
              <span className="errStar">*</span>
            </div>
              </>
              )
            }
            </div>
            
          </div>
          
        </div>
      
      <div className="container signIncont">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-5 col-12 createAcounBtn">

            {/* <div><input style={{ marginRight:'5px'}} checked={isChecked} onChange={handleCheckboxChange} type="checkbox"/><p style={{cursor:'pointer', marginLeft:'10px',textDecoration: 'underline'}} className="agreeTerms" onClick={()=>{handleShowModal2()}}>Accept terms and conditions</p></div> */}
          <span style={{display:'flex', justifyContent:'center',alignItems:'center',marginBottom:'10px'}}>  <input style={{marginTop:'0px', marginRight:'5px'}} checked={isChecked} onChange={handleCheckboxChange} type="checkbox"/><p style={{cursor:'pointer', marginLeft:'10px',textDecoration: 'underline',marginBottom:'0px'}} className="agreeTerms" onClick={()=>{handleShowModal2()}}>Accept terms and conditions</p></span>
            <input
              value="Create account"
              className="singSecure"
              type="button"
              onClick={() => formHandler1()}
            />
            
            <button className="singinBack" style={{border:'none', backgroundColor:'#fff', color:'gray'}} onClick={()=>{goBack()}}>BACK</button>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg" className='modalClass'>
        <Modal.Header closeButton style={{background:'rgba(241, 241, 241, 1)'}}>
          {/* <Modal.Title>OTP Verification</Modal.Title> */}
        </Modal.Header>
        <Modal.Body style={{height:'450px', background:'rgba(241, 241, 241, 1)'}}>
          <Loginotp mobileNo={mobileNo} Name={Name} mobileNo2={mobileNo2} email={email} lastName={lastName} gstin={gstn} companyName={companyName} company={companyStatus}/>
        </Modal.Body>
      </Modal>

      <Modal show={showModal2} onHide={handleCloseModal2} centered  size="lg" className='modalClass'  >
      <Modal.Header closeButton style={{background:'rgba(241, 241, 241, 1)'}}>
      <h2 className='' style={{fontSize:'30px'}}>Terms And Conditions</h2>
        </Modal.Header>
        
        <Modal.Body style={{height:'450px', background:'rgba(241, 241, 241, 1)'}}>
        <div className="termsModal">
   
      <div className=''>
        <h3 className='cookies'>General Terms</h3><br/>
        By accessing and placing an order with www.creativecarcare.in, you confirm that you are in agreement with and bound by the terms of service contained in the Terms & Conditions outlined below. These terms apply to the entire website and any email or other type of communication between you and Creative Car Care. <br/>
        <br/>
       
        Under no circumstances shall the www.creativecarcare.in team be liable for any direct, indirect, special, incidental, or consequential damages, including, but not limited to, loss of data or profit, arising out of the use, or the inability to use, the materials on this site, even if www.creativecarcare.in team or an authorized representative has been advised of the possibility of such damages. If your use of materials from this site results in the need for servicing, repair or correction of equipment or data, you assume any costs thereof www.creativecarcare.in will not be responsible for any outcome that may occur during the course of usage of our resources. We reserve the rights to change prices and revise the resources usage policy in any moment.

        <h3 className='cookies2'>License</h3>
        www.creativecarcare.in grants you a revocable, non-exclusive, non-transferable, limited license to download, install and use the website strictly in accordance with the terms of this Agreement.
These Terms & Conditions are a contract between you and www.creativecarcare.in (referred to in these Terms & Conditions as "Creative Car Care", "us", "we" or "our"), the provider of the www.creativecarcare.in website and the services accessible from the www.creativecarcare.in website (which are collectively referred to in these Terms & Conditions as the "www.creativecarcare.in Service").
You are agreeing to be bound by these Terms & Conditions. If you do not agree to these Terms &
Conditions, please do not use the www.creativecarcare.in Service. In these Terms & Conditions, "you" refers both to you as an individual and to the entity you represent. If you violate any of these Terms & Conditions, we reserve the right to cancel your account or block access to your account without notice.

<h3 className='cookies2'>Definitions and key terms</h3>
To help explain things as clearly as possible in this Terms & Conditions, every time any of these terms are referenced, are strictly defined as Cookie: small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.l Company: when this terms mention “Company,” “we,” “us,” or “our,” it refers to CREATIVE INTERNATIONAL, (UNIT 1, JANTA COMPOUND, 162, SENAPATI BAPAT MARG, LOWER PAREL (W), MUMBAI - 400013), that is responsible for your information under this Terms & Conditions. 
l Country: where www.creativecarcare.in or the owners/founders of www.creativecarcare.in are based, in this case is INDIA l Device: any internet connected device such as a phone, tablet, computer or any other device that can be used to visit www.creativecarcare.in and use the services. l Service: refers to the service provided by www.creativecarcare.in as described in the relative terms (if available) and on this platform.l Third-party service: refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you. l Website: Creative Car Care’s site, which can be accessed via this URL: www.creativecarcare.in l You: a person or entity that is registered with www.creativecarcare.in to use the Services.

<h3 className='cookies2'>Restrictions</h3>
You agree not to, and you will not permit others to: l License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the website or make the platform available to any third party. l Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the website. l Remove, alter or obscure any proprietary notice (including any notice of copyright or trademark) of www.creativecarcare.in or its affiliates, partners, suppliers or the licensors of the website.
<h3 className='cookies2'>Payment</h3>
If you pay for any of our one-time payment plans, you agree to pay all fees or charges to your account for the Service in accordance with the fees, charges and billing terms in effect at the time that each fee or charge is due and payable. Your Payment Provider agreement governs your use of the designated credit card account, and you must refer to that agreement and not these Terms to determine your rights and liabilities with respect to your Payment Provider. By providing www.creativecarcare.in with your credit card number and associated payment information, you agree that www.creativecarcare.in is authorized to verify information immediately, and subsequently invoice your account for all fees and charges due and payable to Creative Car Care hereunder and that no additional notice or consent is required. You agree to immediately notify www.creativecarcare.in of any change in your billing address or the credit card used for payment hereunder www.creativecarcare.in reserves the right at any time to change its prices and billing methods, either immediately upon posting on our Site or by e-mail delivery to your organization’s administrator(s). Any attorney fees, court costs, or other costs incurred in the collection of delinquent undisputed amounts shall be the responsibility of and paid for by you.
<br/>
<br/>
No contract will exist between you and www.creativecarcare.in for the Service until www.creativecarcare.in accepts your order by a confirmatory e-mail, SMS/MMS message, or other appropriate means of communication. You are responsible for any third-party fees that you may incur when using the Service.
<h3 className='cookies2'>Loyalty Points </h3>
Earning Loyalty Points:
<br/>
<br/>
For every 100 rupees spent on our website, you will earn 5 loyalty points. These points will be credited to your account after the successful completion of your purchase.
<br/>
<br/>
Redeeming Loyalty Points:
<br/>
<br/>
You can use your accumulated loyalty points to make purchases on our website. For every 1 loyalty point, you can offset the value of 1 rupee from your total order amount. (1 Point = 1 Rupee)
<br/>
<br/>
We value your loyalty and are excited to reward you for your continued support. If you have any inquiries or require further clarification about our loyalty points program, please don't hesitate to get in touch with our customer service team.


<h3 className='cookies2'>Your Suggestions</h3>
Any feedback, comments, ideas, improvements or suggestions (collectively, "Suggestions") provided by you to www.creativecarcare.in with respect to the website shall remain the sole and exclusive property of Creative Car Care.
www.creativecarcare.in shall be free to use, copy, modify, publish, or redistribute the Suggestions for any purpose and in any way without any credit or any compensation to you.

<h3 className='cookies2'>Your Consent</h3>
We've updated our Terms & Conditions to provide you with complete transparency into what is being set when you visit our site and how it's being used. By using our website, registering an account, or making a purchase, you hereby consent to our Terms & Conditions.
<h3 className='cookies2'> Links to Other Websites</h3>
This Terms & Conditions applies only to the Services. The Services may contain links to other websites not operated or controlled by Creative Car Care. We are not responsible for the content, accuracy or opinions expressed in such websites, and such websites are not investigated, monitored or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Terms & Conditions are no longer in effect. Your browsing and interaction on any other website, including those that have a link on our platform, is subject to that website’s own rules and policies. Such third parties may use their own cookies or other methods to collect information about you.
<h3 className='cookies2'>Cookies</h3>
www.creativecarcare.in uses "Cookies" to identify the areas of our website that you have visited. A Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use Cookies to enhance the performance and functionality of our website but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable or you would be required to enter your login details every time you visit the website as we would not be able to remember that you had logged in previously. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies, you may not be able to access functionality on our website correctly or at all. We never place Personally Identifiable Information in Cookies.
<h3 className='cookies2'>Changes To Our Terms & Conditions</h3>
You acknowledge and agree that www.creativecarcare.in may stop (permanently or temporarily) providing the Service (or any features within the Service) to you or to users generally at Creative Car Care’s sole discretion, without prior notice to you. You may stop using the Service at any time. You do not need to specifically inform www.creativecarcare.in when you stop using the Service. You acknowledge and agree that if www.creativecarcare.in disables access to your account, you may be prevented from accessing the Service, your account details or any files or other materials which is contained in your account. If we decide to change our Terms & Conditions, we will post those changes on this page, and/or update the Terms & Conditions modification date below.
 <h3 className='cookies2'>Modifications to Our website</h3>
 www.creativecarcare.in reserves the right to modify, suspend or discontinue, temporarily or permanently, the website or any service to which it connects, with or without notice and without liability to you.

<h3 className='cookies2'>Updates to Our website</h3>
www.creativecarcare.in may from time to time provide enhancements or improvements to the features/
functionality of the website, which may include patches, bug fixes, updates, upgrades and other
modifications ("Updates"). Updates may modify or delete certain features and/or functionalities of the website. You agree that Creative Car Care has no obligation to (i) provide any Updates, or (ii) continue to provide or enable any particular features and/or functionalities of the website to you. You further agree that all Updates will be (i) deemed to constitute an integral part of the website, and (ii) subject to the terms and conditions of this Agreement.

<h3 className='cookies2'>Third-Party Services</h3>
We may display, include or make available third-party content (including data, information, applications and other products services) or provide links to third-party websites or services ("Third- Party Services").
You acknowledge and agree that www.creativecarcare.in shall not be responsible for any Third-Party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. www.creativecarcare.in does not assume and shall not have any liability or responsibility to you or any other person or entity for any Third-Party Services.
Third-Party Services and links thereto are provided solely as a convenience to you and you access and use them entirely at your own risk and subject to such third parties' terms and conditions.

<h3 className='cookies2'>Term and Termination</h3><br/>
This Agreement shall remain in effect until terminated by you or Creative Car Care. www.creativecarcare.in  may, in its sole discretion, at any time and for any or no reason, suspend or terminate this Agreement with or without prior notice.<br/>
This Agreement will terminate immediately, without prior notice from Creative Car Care, in the event that you fail to comply with any provision of this Agreement. You may also terminate this Agreement by deleting the website and all copies thereof from your computer. Upon termination of this Agreement, you shall cease all use of the website and delete all copies of the website from your computer.<br/>
Termination of this Agreement will not limit any of Creative Car Care's rights or remedies at law or in equity in case of breach by you (during the term of this Agreement) of any of your obligations under the present Agreement.

<h3 className='cookies2'>Copyright Infringement Notice</h3>
If you are a copyright owner or such owner’s agent and believe any material on our website constitutes an infringement on your copyright, please contact us setting forth the following information: (a) a physical or electronic signature of the copyright owner or a person authorized to act on his behalf; (b) identification of the material that is claimed to be infringing; (c) your contact information, including your address, telephone number, and an email; (d) a statement by you that you have a good faith belief that use of the material is not authorized by the copyright owners; and (e) a statement that the information in the notification is accurate, and, under penalty of perjury you are authorized to act on behalf of the owner.
<h3 className='cookies2'>Indemnification</h3> <br/>
You agree to indemnify and hold www.creativecarcare.in and its parents, subsidiaries, affiliates, officers, employees, agents, partners and licensors (if any) harmless from any claim or demand, including reasonable attorneys' fees, due to or arising out of your: (a) use of the website; (b) violation of this Agreement or any law or regulation; or (c) violation of any right of a third party.
<h3 className='cookies2'>No Warranties</h3><br/>
The website is provided to you "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, Creative Car Care, on its own behalf and on behalf of its affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the website, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, www.creativecarcare.in provides no warranty or undertaking, and makes no representation of any kind that the website will meet your requirements, achieve any intended results, be compatible or work with any other software, websites, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected. Without limiting the foregoing, neither www.creativecarcare.in nor any Creative Car Care's provider makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the website, or the information, content, and materials or products included thereon; (ii) that the website will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the website; or (iv) that the website, its servers, the content, or e-mails sent from or on behalf of www.creativecarcare.in are free of viruses, scripts, trojan horses, worms, malware, timebombs or other
harmful components. Some jurisdictions do not allow the exclusion of or limitations on implied warranties or the limitations on the applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to you.

<h3 className='cookies'>Limitation of Liability</h3><br/>
Notwithstanding any damages that you might incur, the entire liability of www.creativecarcare.in and any of its suppliers under any provision of this Agreement and your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by you for the website. To the maximum extent permitted by applicable law, in no event shall www.creativecarcare.in or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, for loss of data or other information, for business interruption, for personal injury, for loss of privacy arising out of or in any way related to the use of or inability to use the website, third-party software and/or third-party hardware used with the website, or otherwise in connection with any provision of this Agreement), even if www.creativecarcare.in or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose. Some states/jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so
the above limitation or exclusion may not apply to you.

<h3 className='cookies'>Severability </h3><br/>
If any provision of this Agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.
This Agreement, together with the Privacy Policy and any other legal notices published by Creative Car Care on the Services, shall constitute the entire agreement between you and www.creativecarcare.in concerning the Services. If any provision of this Agreement is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of this Agreement, which shall remain in full force and effect. No waiver of any term of this Agreement shall be deemed a further or continuing waiver of such term or any other term, and Creative Car Care’s failure to assert any right or provision under this Agreement shall not constitute a waiver of such right or provision. YOU AND Creative Car Care AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.

<h3 className='cookies2'>Waiver</h3>
Except as provided herein, the failure to exercise a right or to require the performance of an obligation under this Agreement shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall be the waiver of a breach constitute waiver of any subsequent breach.
No failure to exercise, and no delay in exercising, on the part of either party, any right or any power under this Agreement shall operate as a waiver of that right or power. Nor shall any single or partial exercise of any right or power under this Agreement preclude further exercise of that or any other right granted herein. In the event of a conflict between this Agreement and any applicable purchase or other terms, the terms of this Agreement shall govern.

<h3 className='cookies'>Amendments to this Agreement</h3><br/>
www.creativecarcare.in reserves the right, at its sole discretion, to modify or replace this Agreement at any time. If a revision is material we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our website after any revisions become effective, you agree to be bound by
the revised terms. If you do not agree to the new terms, you are no longer authorized to use Creative Car Care.
 <br/>


<h3 className='cookies2'>Entire Agreement</h3>
The Agreement constitutes the entire agreement between you and www.creativecarcare.in regarding your use of the website and supersedes all prior and contemporaneous written or oral agreements between you and Creative Car Care. You may be subject to additional terms and conditions that apply when you use or purchase other Creative Car Care's services, which www.creativecarcare.in will provide to you at the time of such use or purchase.<br/>
<h3 className='cookies'>Updates to Our Terms</h3><br/>
We may change our Service and policies, and we may need to make changes to these Terms so that they accurately reflect our Service and policies. Unless otherwise required by law, we will notify you (for example, through our Service) before we make changes to these Terms and give you an opportunity to review them before they go into effect. Then, if you continue to use the Service, you will be bound by the updated Terms. If you do not want to agree to these or any updated Terms, you can delete your account.<br/>
<h3 className='cookies'>Intellectual Property</h3><br/>

The website and its entire contents, features and functionality (including but not limited to all information,
software, text, displays, images, video and audio, and the design, selection and arrangement thereof), are owned by Creative Car Care, its licensors or other providers of such material and are protected by INDIA and international copyright, trademark, patent, trade secret and other intellectual property or proprietary rights laws. The material may not be copied, modified, reproduced, downloaded or distributed in any way, in whole or in part, without the express prior written permission of Creative Car Care, unless and except as is expressly provided in these Terms & Conditions. Any unauthorized use of the material is prohibited.
<br/>
<h3 className='cookies'>Agreement to Arbitrate</h3><br/>
This section applies to any dispute EXCEPT IT DOESN’T INCLUDE A DISPUTE RELATING TO CLAIMS FOR INJUNCTIVE OR EQUITABLE RELIEF REGARDING THE ENFORCEMENT OR VALIDITY OF YOUR OR Creative Car Care’s INTELLECTUAL PROPERTY RIGHTS. The term “dispute” means any dispute, action, or other controversy between you and www.creativecarcare.in concerning the Services or this agreement, whether in contract, warranty, tort, statute, regulation, ordinance, or any other legal or equitable basis. “Dispute” will be given the broadest possible meaning allowable under law.<br/>
<h3 className='cookies'>Notice of Dispute</h3><br/>
In the event of a dispute, you or www.creativecarcare.in must give the other a Notice of Dispute, which is a written statement that sets forth the name, address, and contact information of the party giving it, the facts giving rise to the dispute, and the relief requested. You must send any Notice of Dispute via email to: support@creativecarcare.in. www.creativecarcare.in will send any Notice of Dispute to you by mail to your address if we have it, or otherwise to your email address. You and www.creativecarcare.in will attempt to resolve any dispute through informal negotiation within sixty (60) days from the date the Notice of Dispute is sent. After sixty (60) days, you or www.creativecarcare.in may commence arbitration.<br/>

<h3 className='cookies'>Binding Arbitration</h3><br/>
If you and www.creativecarcare.in don’t resolve any dispute by informal negotiation, any other effort to resolve the dispute will be conducted exclusively by binding arbitration as described in this section. You are giving up the right to litigate (or participate in as a party or class member) all disputes in court before a judge or jury. Either party may seek any interim or preliminary injunctive relief from any court of competent jurisdiction, as necessary to protect the party’s rights or property pending the completion
of arbitration. Any and all legal, accounting, and other costs, fees, and expenses incurred by the prevailing party shall be borne by the non-prevailing party.
<br/>
<h3 className='cookies'>Submissions and Privacy</h3><br/>
In the event that you submit or post any ideas, creative suggestions, designs, photographs, information,
advertisements, data or proposals, including ideas for new or improved products, services, features,
technologies or promotions, you expressly agree that such submissions will automatically be treated as
non-confidential and non-proprietary and will become the sole property of www.creativecarcare.in  without any compensation or credit to you whatsoever. www.creativecarcare.in and its affiliates shall have no obligations with respect to such submissions or posts and may use the ideas contained in such submissions or posts for any purposes in any medium in perpetuity, including, but not limited to, developing, manufacturing, and marketing products and services using such ideas.
<br/>
<h3 className='cookies'>Promotions</h3><br/>
www.creativecarcare.in may, from time to time, include contests, promotions, sweepstakes, or other activities (“Promotions”) that require you to submit material or information concerning yourself. Please note that all Promotions may be governed by separate rules that may contain certain eligibility requirements, such as restrictions as to age and geographic location. You are responsible to read all Promotions rules to determine whether or not you are eligible to participate. If you enter any Promotion, you agree to abide by and to comply with all Promotions Rules.<br/>
Additional terms and conditions may apply to purchases of goods or services on or through the Services, which terms and conditions are made a part of this Agreement by this reference.

<br/>
<h3 className='cookies'>Typographical Errors</h3><br/>
In the event a product and/or service is listed at an incorrect price or with incorrect information due to
typographical error, we shall have the right to refuse or cancel any orders placed for the product and/or
service listed at the incorrect price. We shall have the right to refuse or cancel any such order whether or not the order has been confirmed and your credit card charged. If your credit card has already been charged for the purchase and your order is cancelled, we shall immediately issue a credit to your credit card account or other payment accounts in the amount of the charge.

<br/>
<h3 className='cookies'>Miscellaneous</h3><br/>
If for any reason a court of competent jurisdiction finds any provision or portion of these Terms & Conditions to be unenforceable, the remainder of these Terms & Conditions will continue in full force and effect. Any waiver of any provision of these Terms & Conditions will be effective only if in writing and signed by an authorized representative of Creative Car Care. www.creativecarcare.in will be entitled to injunctive or other equitable relief (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by you. www.creativecarcare.in operates and controls the www.creativecarcare.in Service from its offices in INDIA. The Service is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation. Accordingly, those persons who choose to access the www.creativecarcare.in Service from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable. These Terms & Conditions (which include and incorporate the www.creativecarcare.in Privacy Policy) contains the entire understanding, and supersedes all prior understandings, between you and Creative Car Care concerning its subject matter, and cannot be changed or modified by you. The section headings used
in this Agreement are for convenience only and will not be given any legal import.

<br/>
<h3 className='cookies'>Disclaimer</h3><br/>
www.creativecarcare.in is not responsible for any content, code or any other imprecision.<br/>
www.creativecarcare.in does not provide warranties or guarantees. In no event shall www.creativecarcare.in be liable for any special, direct, indirect, consequential, or incidental
damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service.<br/> The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice.
The www.creativecarcare.in Service and its contents are provided "as is" and "as available" without any warranty or representations of any kind, whether express or implied. www.creativecarcare.in is a distributor and not a publisher of the content supplied by third parties; as such, www.creativecarcare.in exercises no editorial control over such content and makes no warranty or representation as to the accuracy, reliability or currency of any information, content, service or merchandise provided through or accessible via the Creative Car Care Service. Without limiting the foregoing, www.creativecarcare.in specifically disclaims all warranties and representations in any content transmitted on or in connection with the www.creativecarcare.in Service or on sites that may appear as links on the www.creativecarcare.in Service, or in the products provided as a part of, or otherwise in connection with, the www.creativecarcare.in Service, including without limitation any warranties of merchantability, fitness for a particular purpose or non-infringement of third-party rights. No oral advice or written information given by www.creativecarcare.in or any of its affiliates, employees, officers, directors, agents, or the like will create a warranty. Price and availability information is subject to change without notice. Without limiting the foregoing, www.creativecarcare.in does not warrant that the www.creativecarcare.in Service will be uninterrupted, uncorrupted, timely, or error-free.

<br/>
<h3 className='cookies'>Contact Us</h3><br/>
<div style={{width:'100%'}}>
Don't hesitate to contact us if you have any questions.
<ul>
  <li>•	l Via Email: <a href="mailto: support@creativecarcare.in" style={{ color: 'black', textDecoration: 'none' }}>support@creativecarcare.in</a> </li>
  <li>• l Via Phone Number: <a href='tel: 99302 90909' style={{textDecoration:'none', color:'black'}}> 9930290909</a></li>
  <li>• l Via this Link: <a href='https://creativecarcare.in/' style={{color:'black', textDecoration:'none'}}>www.creativecarcare.in</a> </li>
</ul>
</div>
<br/>
      </div>
    </div>
        </Modal.Body>
      </Modal>
      <Footer/>
    </>
  );
};

export default NewAcount;
